import { qs, qsAll } from '../utils/domHelpers.js';

export class PseudoSelect {
  constructor(baseQueryEl) {
    this.baseQueryEl = baseQueryEl;
  }

  init() {
    const pseudoSelects = qsAll('.select__wrap--pseudo', this.baseQueryEl);
    if (pseudoSelects.length > 0) {
      pseudoSelects.forEach((select) => {
        const label = qs('label', select);
        if (label) {
          const toggleOptions = () => {
            select.classList.toggle('options--open');
            if (select.classList.contains('options--open')) {
              const closeOptions = (e) => {
                if (!select.contains(e.target)) {
                  select.classList.remove('options--open');
                  document.removeEventListener('click', closeOptions);
                }
              };
              document.addEventListener('click', closeOptions);
            }
          };

          label.addEventListener('click', toggleOptions);
          label.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleOptions();
            }
            if (e.key === 'Escape') {
              select.classList.remove('options--open');
            }
            // if (e.key === 'Tab') {
            //   select.classList.remove('options--open');
            // }
          });

          // Ensure it's tabbable
          label.setAttribute('tabindex', '0');
          label.setAttribute('role', 'button');

          select.addEventListener('click', (e) => {
            const option = e.target.closest('[data-variant-id]');
            if (option) {
              const variantId = option.getAttribute('data-variant-id');
              const matchingImages = document.querySelectorAll(`[data-variant="${variantId}"]`);
              // console.log(`Selected Variant ID: ${variantId}`);
              // console.log('Matching Images:', matchingImages);

              const mediaContainers = Array.from(document.querySelectorAll('.product-media-container'));
              const thumbnails = Array.from(document.querySelectorAll('.gallery__thumbnail'));

              if (matchingImages.length > 0 && mediaContainers.length > 0 && thumbnails.length > 0) {
                const matchedImage = matchingImages[0];
                const matchedContainer = matchedImage.closest('.product-media-container');
                const index = mediaContainers.indexOf(matchedContainer);

                if (index !== -1 && thumbnails[index]) {
                  thumbnails[index].click();
                }
              }
            }
          });
        }
      });
    }
  }
}
